import moment from 'momentExt'

// Free plan advertises a 12-month data lookback (see Plan/planConfig.tsx).
// All limited-access users get the same 12-month window.
export const LIMITED_ACCESS_LOOKBACK_MONTHS = 12
export const FREE_PLAN_LOOKBACK_MONTHS = LIMITED_ACCESS_LOOKBACK_MONTHS
export const LITE_PLAN_DAYS = 30

/**
 * Whether a subscription is the "Lite" shipping-tier variant.
 * Lite is a billing flag on a non-paid (Free) product, not a separate product —
 * so it must be checked explicitly, not inferred from `product`. Single source of
 * truth shared with Root.tsx so the picker and route gating agree on what "lite" is.
 */
export const isLiteSubscription = (subscription?: any, user?: any): boolean => {
  const product = subscription?.plans?.[0]?.product
  const isPaidPlan = !!product && product !== 'Free'
  return !isPaidPlan && (!!user?.billing?.lite || !!subscription?.plans?.[0]?.lite)
}

/**
 * Earliest date a limited-access user is allowed to select.
 * All limited-access accounts (Free, Lite, inactive) get a 12-month window.
 */
export const getLimitedAccessMinDate = (_subscription?: any, _user?: any): Date => {
  // Normalize to start-of-day so the boundary day itself is selectable
  // (a midnight calendar selection must not lose to the current time-of-day).
  return moment().subtract(LIMITED_ACCESS_LOOKBACK_MONTHS, 'months').startOf('day').toDate()
}
